import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import WardSelector from './components/WardSelector';
import RoadSelectionApp from './components/RoadSelectionApp';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/deliveryplanner" element={<WardSelector />} />
        <Route path="/deliveryplanner/:wardSlug" element={<RoadSelectionApp />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/" element={<Navigate to="/deliveryplanner" replace />} />
        <Route path="*" element={<Navigate to="/deliveryplanner" replace />} />
      </Routes>
    </Router>
  );
}

export default App;